export const hasProvidedValue = (value) => {
  if (value == null) return false;
  return typeof value === 'string' ? value.trim() !== '' : true;
};

export const firstProvided = (...candidates) => candidates.find(hasProvidedValue);

export const normalizeCreditCardValues = (source = {}) => ({
  creditCardCurrent: firstProvided(source.ccCurrent, source.creditCardCurrent),
  creditCardPosted: firstProvided(source.ccPosted, source.creditCardPosted),
});
